import { FC } from 'react'
import { Section } from 'modules/Cube/view/common/atomic/Section'
import {
  Text,
  Primary14SemiBold,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'

type WidgetSectionProps = {
  title: string
  options?: React.ReactNode
  children: React.ReactNode
  width?: string
  hideTitle?: boolean
}

export const WidgetSection: FC<WidgetSectionProps> = ({
  title,
  options,
  children,
  width,
  hideTitle = false
}) => {
  return (
    <Section width={width}>
      <Grid
        templateColumns="1fr auto"
        templateRows="auto auto"
        templateAreas={`"title options"
        "content content"
        `}
      >
        {!hideTitle && (
          <GridItem
            area="title"
            justifyContent="space-between"
            width="100%"
            pt="20px"
            pb="16px"
            px="24px"
            userSelect="none"
          >
            <Text {...Primary14SemiBold}>{title}</Text>
          </GridItem>
        )}
        <Flex
          gridArea="options"
          alignItems="center"
          justifyContent="space-between"
          gap="8px"
          width="100%"
          pt="20px"
          pb="16px"
          px="24px"
        >
          {options}
        </Flex>
        <GridItem area="content">{children}</GridItem>
      </Grid>
    </Section>
  )
}
